<div class="modal-header">
    <h4 class="modal-title" translate="users.exportModal.title"></h4>

    <button class="btn-close" type="button" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')">
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="exportForm">
        <div class="row">
            <app-custom-role-management
                [enableAllCustomers]="true"
                [validationRequired]="true"
                formControlName="customRoles">
            </app-custom-role-management>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button"
            (click)="activeModal.close()"
            translate="common.cancel">
    </button>

    <button type="submit" (click)="exportCustomers()" class="btn btn-primary"
            [disabled]="exportForm.invalid" translate="users.exportModal.actions.export">
    </button>
</div>
